// extracted by mini-css-extract-plugin
module.exports = {"CustomButtom":"Button_CustomButtom__MYLxO","addIcon":"Button_addIcon__ZD5Ri","icon":"Button_icon__PJfa6","ButtonLink":"Button_ButtonLink__eIPOO"};